import { defineAsyncComponent } from "vue";

export default {
  forms: {
    list: {
      component: defineAsyncComponent(() => import("./forms/List.vue")),
    },
    edit: {
      component: defineAsyncComponent(() => import("./forms/Edit.vue")),
    },
    select: {
      panel: {
        width: "50%",
      },
      config: {
        sorting: true,
        actions: {
          view: true,
          edit: false,
          create: false,
          copy: false,
          delete: false,
        },
        fields: {
          id: {
            config: {
              visible: false,
            },
          },
          name: {
            config: {
              sorting: "blocks.name",
            },
          },
          floor_name: {
            config: {
              sorting: "blocks.floor_name",
            },
          },
          doctor_id: {
            config: {
              sorting: "blocks.doctor_id",
            },
          },
        },
      },
    },
  },
};
